import { RootState } from '../index';

export const resultsSelector = (state: RootState) => state.bitesFeed.results;
export const nextPageSelector = (state: RootState) => state.bitesFeed.nextPage;
export const isLoadingSelector = (state: RootState) => state.bitesFeed.isLoading;
export const searchStrSelector = (state: RootState) => state.bitesFeed.searchStr;
export const isWithoutEmptyBitesSelector = (state: RootState) => state.bitesFeed.isWithoutEmptyBites;
